export default {
    AUCTIONEER_DATA_TEMPLATE_CREATED: 'AUCTIONEER_DATA_TEMPLATE_CREATED',
    AUCTIONEER_DATA_TEMPLATE_UPDATED: 'AUCTIONEER_DATA_TEMPLATE_UPDATED',
    AUCTIONEER_DATA_TEMPLATE_DELETED: 'AUCTIONEER_DATA_TEMPLATE_DELETED',

    AUCTION_CREATED: 'AUCTION_CREATED',
    AUCTION_UPDATED: 'AUCTION_UPDATED',
    AUCTION_DELETED: 'AUCTION_DELETED',

    AUCTION_TEMPLATE_CREATED: 'AUCTION_TEMPLATE_CREATED',
    AUCTION_TEMPLATE_DELETED: 'AUCTION_TEMPLATE_DELETED',

    EMAIL_TEMPLATE_CREATED: 'EMAIL_TEMPLATE_CREATED',
    EMAIL_TEMPLATE_UPDATED: 'EMAIL_TEMPLATE_UPDATED',
    EMAIL_TEMPLATE_DELETED: 'EMAIL_TEMPLATE_DELETED',

    AUCTION_LIMIT_CREATED: 'AUCTION_LIMIT_CREATED',
    AUCTION_LIMIT_UPDATED: 'AUCTION_LIMIT_UPDATED',
    AUCTION_LIMIT_DELETED: 'AUCTION_LIMIT_DELETED',

    AUCTION_BIDS_CHANGED: 'AUCTION_BIDS_CHANGED',

    BIDS_CREATED: 'BIDS_CREATED',
    BIDS_UPDATED: 'BIDS_UPDATED',
    BIDS_DELETED: 'BIDS_DELETED',

    CLEARING_HOUSE_CREATED: 'CLEARING_HOUSE_CREATED',
    CLEARING_HOUSE_UPDATED: 'CLEARING_HOUSE_UPDATED',
    CLEARING_HOUSE_DELETED: 'CLEARING_HOUSE_DELETED',

    SUBMARKET_CREATED: 'SUBMARKET_CREATED',
    SUBMARKET_UPDATED: 'SUBMARKET_UPDATED',

    CURRENCY_CREATED: 'CURRENCY_CREATED',
    CURRENCY_UPDATED: 'CURRENCY_UPDATED',

    HOLIDAY_CREATED: 'HOLIDAY_CREATED',
    HOLIDAY_UPDATED: 'HOLIDAY_UPDATED',

    MANUAL_CASH_LIMIT_CREATED: 'MANUAL_CASH_LIMIT_CREATED',
    MANUAL_CASH_LIMIT_DELETED: 'MANUAL_CASH_LIMIT_DELETED',

    MEMBER_CREATED: 'MEMBER_CREATED',
    MEMBER_UPDATED: 'MEMBER_UPDATED',

    MESSAGE_CREATED: 'MESSAGE_CREATED',

    PRODUCT_CREATED: 'PRODUCT_CREATED',
    PRODUCT_UPDATED: 'PRODUCT_UPDATED',

    USER_CREATED: 'USER_CREATED',
    USER_UPDATED: 'USER_UPDATED',

    ZONE_CREATED: 'ZONE_CREATED',
    ZONE_UPDATED: 'ZONE_UPDATED',
};
